import { useNavigate } from "react-router";
import { Button } from "antd";
import AskVivoIcon from "@/assets/icons/ask_vivo2.svg?react";
import ArchiveIcon from "@/assets/icons/archive.svg?react";
import EditIcon from "@/assets/icons/edit_pencil.svg?react";
import ActivateIcon from "@/assets/icons/archive_action.svg?react";
import { InsightProps } from "./insights";
import { isInsightArchived } from "./utils";
import { useScopeParams } from "@/hooks/useScopeParams";
import { useSuperuserMode } from "@/contexts/useSuperuser";

type DrawerFooterProps = {
  insight: InsightProps;
  question: string;
  onClose: () => void;
  onEdit: (insight: InsightProps) => void;
  onArchive: (insight: InsightProps) => void;
  onActivate: (insight: InsightProps) => void;
};

export default function DrawerFooter({
  insight,
  question,
  onClose,
  onEdit,
  onArchive,
  onActivate,
}: DrawerFooterProps) {
  const { buildUrl } = useScopeParams();
  const navigate = useNavigate();
  const { isSuperuserMode } = useSuperuserMode();
  const canMutateSharedInsight = !insight.is_shared || isSuperuserMode;

  const goToAskVivo = () =>
    navigate(buildUrl("askvivo"), {
      state: { question: question },
    });

  const handleArchive = () => {
    onArchive(insight);
    onClose();
  };

  const handleActivate = () => {
    onActivate(insight);
    onClose();
  };

  const handleEdit = () => {
    onEdit(insight);
  };

  return (
    <div
      className={`flex items-center py-1 ${
        canMutateSharedInsight ? "justify-between" : "justify-end"
      }`}
    >
      {canMutateSharedInsight &&
        (isInsightArchived(insight) ? (
          <Button
            onClick={handleActivate}
            className="border border-[#00000073] text-[#2b4752]"
          >
            <ActivateIcon />
            <span>Activate</span>
          </Button>
        ) : (
          <Button
            onClick={handleArchive}
            className="border border-[#00000073] text-[#2b4752]"
          >
            <ArchiveIcon />
            <span>Archive</span>
          </Button>
        ))}

      <div className="flex items-center justify-between gap-3">
        {canMutateSharedInsight && !isInsightArchived(insight) && (
          <Button
            onClick={handleEdit}
            className="bg-[#D2EFF9] text-[#06709B] border border-[#06709B]"
          >
            <EditIcon />
            <span>Edit</span>
          </Button>
        )}

        <Button type="primary" onClick={goToAskVivo}>
          <AskVivoIcon />
          <span>Ask Vivo</span>
        </Button>
      </div>
    </div>
  );
}
